(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-add-to-cart-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-add-to-cart-button')) {
    class TdAddToCartButton extends HTMLElement {
      constructor() {
        super();
        this.error = false;
        this.clickHandler = null;
        this.observer = null;
      }

      connectedCallback() {
        // Get attributes from the web component element
        this.productId = this.getAttribute('data-product-id');
        this.buttonId = this.getAttribute('data-button-id');
        
        // Get cart reference
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        // Wait for next frame to ensure DOM is fully parsed
        requestAnimationFrame(() => {
          this.initializeButton();
        });
      }

      initializeButton() {
        // Find the button within this web component instance
        this.button = this.querySelector('[data-td-add-to-cart]');
        
        // If button found, attach listener
        if (this.button) {
          this.attachListener();
          return;
        }

        // If button not found, set up MutationObserver to watch for button being added
        this.setupObserver();
      }

      setupObserver() {
        // Watch for button being added to the DOM
        this.observer = new MutationObserver((mutations) => {
          this.button = this.querySelector('[data-td-add-to-cart]');
          if (this.button) {
            this.attachListener();
            if (this.observer) {
              this.observer.disconnect();
              this.observer = null;
            }
          }
        });

        this.observer.observe(this, {
          childList: true,
          subtree: true
        });
      }

      attachListener() {
        // Validate before attaching listener
        if (!this.button || !this.productId) {
          console.warn('td-add-to-cart-button: Missing button or productId', {
            hasButton: !!this.button,
            productId: this.productId,
            buttonId: this.buttonId
          });
          return;
        }

        // Store reference to this instance's button
        this.instanceButton = this.button;
        
        // Create bound handler and store it for cleanup
        this.clickHandler = this.addToCart.bind(this);
        this.button.addEventListener('click', this.clickHandler);
      }

      disconnectedCallback() {
        // Clean up event listener when component is removed
        if (this.button && this.clickHandler) {
          this.button.removeEventListener('click', this.clickHandler);
        }
        // Clean up observer
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }


      addToCart(event) {
        // Stop event propagation to prevent multiple handlers
        if (event) {
          event.stopPropagation();
        }

        // Use the instance's button, not a query result
        const button = this.instanceButton || this.button;
        
        if (!this.productId || !button || button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        // Disable this specific button
        button.setAttribute('aria-disabled', 'true');

        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        const data = {
          items: [{
            quantity: 1,
            id: this.productId
          }]
        }

        if (this.cart) {
          data.sections = this.cart.getSectionsToRender().map((section) => section.id);
          data.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            console.error('Error:', response.description);
            button.setAttribute('aria-disabled', true);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error && typeof publish !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'td-add-to-cart-button'});
          }
          this.error = false;
          this.cart.renderContents(response);
        })
        .catch((error) => {
          console.error('Error:', error);
          this.error = true;
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error && button) {
            button.removeAttribute('aria-disabled');
          }
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        })
      }
    }

    customElements.define('td-add-to-cart-button', TdAddToCartButton);
  }
  } catch(e) { console.error(e); }
})();

})();
